import script from "./BootcampSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./BootcampSettings.vue?vue&type=script&setup=true&lang=js"

import "./BootcampSettings.vue?vue&type=style&index=0&id=8df61674&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8df61674"]])

export default __exports__